// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableShift_container__6M38p {
    font-family: Arial, sans-serif;
    padding: 20px;
  }
  
  .TableShift_table__PYGMR {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  .TableShift_table__PYGMR th,
  .TableShift_table__PYGMR td {
    border: 1px solid #8ca7a6;
    padding: 10px;
    text-align: center;
  }
  .TableShift_table__PYGMR th {
    background-color: #8ca7a6;
    color: white;

  }
  .TableShift_button__X-aFf {
    padding: 5px 10px;
    background-color: red;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 5px;
  }
  
  .TableShift_button__X-aFf:hover {
    background-color: darkred;
  }
  
  .TableShift_modal__\\+ExwY {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .TableShift_modalContent__er9M4 {
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    text-align: center;
  }
  
  .TableShift_confirmButton__mlKLg {
    padding: 10px 20px;
    background-color: green;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 5px;
    margin-right: 10px;
  }
  
  .TableShift_cancelButton__ANeaA {
    padding: 10px 20px;
    background-color: gray;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 5px;
  }
  
  .TableShift_confirmButton__mlKLg:hover {
    background-color: darkgreen;
  }
  
  .TableShift_cancelButton__ANeaA:hover {
    background-color: darkgray;
  }
  
  .TableShift_viewInformation__nzqH- {
    text-decoration: underline;
    cursor: pointer;
    transition: color 0.5s ease;
  }

  .TableShift_viewInformation__nzqH-:hover {
  color: #8ca7a6;
  }

  .TableShift_status_bg__786Y8 {
    background-color: rgb(255, 213, 0);
    padding: 5px;
    border-radius: 3px;
    color: black;
  }

 `, "",{"version":3,"sources":["webpack://./src/styles/PanelAdmin/TableShift.module.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;;IAEE,yBAAyB;IACzB,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,YAAY;;EAEd;EACA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,2BAA2B;EAC7B;;EAEA;EACA,cAAc;EACd;;EAEA;IACE,kCAAkC;IAClC,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd","sourcesContent":[".container {\n    font-family: Arial, sans-serif;\n    padding: 20px;\n  }\n  \n  .table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n  }\n  \n  .table th,\n  .table td {\n    border: 1px solid #8ca7a6;\n    padding: 10px;\n    text-align: center;\n  }\n  .table th {\n    background-color: #8ca7a6;\n    color: white;\n\n  }\n  .button {\n    padding: 5px 10px;\n    background-color: red;\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n  }\n  \n  .button:hover {\n    background-color: darkred;\n  }\n  \n  .modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .modalContent {\n    background-color: white;\n    padding: 20px;\n    border-radius: 5px;\n    text-align: center;\n  }\n  \n  .confirmButton {\n    padding: 10px 20px;\n    background-color: green;\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n    margin-right: 10px;\n  }\n  \n  .cancelButton {\n    padding: 10px 20px;\n    background-color: gray;\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n  }\n  \n  .confirmButton:hover {\n    background-color: darkgreen;\n  }\n  \n  .cancelButton:hover {\n    background-color: darkgray;\n  }\n  \n  .viewInformation {\n    text-decoration: underline;\n    cursor: pointer;\n    transition: color 0.5s ease;\n  }\n\n  .viewInformation:hover {\n  color: #8ca7a6;\n  }\n\n  .status_bg {\n    background-color: rgb(255, 213, 0);\n    padding: 5px;\n    border-radius: 3px;\n    color: black;\n  }\n\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TableShift_container__6M38p`,
	"table": `TableShift_table__PYGMR`,
	"button": `TableShift_button__X-aFf`,
	"modal": `TableShift_modal__+ExwY`,
	"modalContent": `TableShift_modalContent__er9M4`,
	"confirmButton": `TableShift_confirmButton__mlKLg`,
	"cancelButton": `TableShift_cancelButton__ANeaA`,
	"viewInformation": `TableShift_viewInformation__nzqH-`,
	"status_bg": `TableShift_status_bg__786Y8`
};
export default ___CSS_LOADER_EXPORT___;
